export default __webpack_public_path__ + "images/camera-outline.svg";